module.exports = __webpack_public_path__ + "static/img/m-lingshou2.c7c5f7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobileImg/m-lingshou2.png
// module id = jTF+
// module chunks = 10